// extracted by mini-css-extract-plugin
export var container = "_95-0";
export var icon = "_95-1";
export var text = "_95-2";